<div class="confirm-cancel-footer d-flex justify-content-end">
  <button class="btn btn-outline-secondary mr-3" [ngClass]="{'disabled': cancelDisabled}" (click)="cancel.emit()">
    <app-loading [promise]="promise" text="Cancelar" i18n-text></app-loading>
  </button>
  <button class="btn btn-primary" [ngClass]="{'disabled': confirmDisabled}" (click)="confirm.emit()">
    <app-loading [promise]="promise" text="Confirmar" i18n-text></app-loading>
  </button>
</div>
